import { useEffect } from 'react';

import useOrgSettingsStore from '../stores/orgSettingsStore';

/**
 * useAdmissionEnabled — single source of truth for "is the Admission (IPD)
 * module on for this org".
 *
 * Lazily fetches the per-org `enable_admission_module` flag once per session
 * and returns it. Every future IPD surface (nav, routes, tabs) gates on this
 * so nothing admission-related renders when the module is off.
 */
export default function useAdmissionEnabled() {
  const enableAdmissionModule = useOrgSettingsStore((s) => s.enableAdmissionModule);
  const admissionLoaded = useOrgSettingsStore((s) => s.admissionLoaded);
  const fetchAdmissionSettings = useOrgSettingsStore((s) => s.fetchAdmissionSettings);

  useEffect(() => {
    if (!admissionLoaded) fetchAdmissionSettings();
  }, [admissionLoaded, fetchAdmissionSettings]);

  return enableAdmissionModule;
}
